import axios from 'axios';
import { FC, useEffect, useState, useRef } from 'react';
import { TreeNode, FileItem } from '../../types/chatTypes'
import { FolderStructureProps } from '../../types/codeBaseType'
import TreeNodeComponent from './TreeNodeComponent'
import './FolderStructure.scss'
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { Icons } from '../../assets/icons/icon';


const FolderStructure: FC<FolderStructureProps> = ({ onContentChange, content }) => {
    const { selectedProject } = useSelector((state: RootState) => state.projectDetails);
    const [tree, setTree] = useState<TreeNode[]>([]);
    const [searchText, setSearchText] = useState("");
    const [filteredTree, setFilteredTree] = useState<TreeNode[]>([]);
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

    const fetchGitHubFiles = async (path: string = ""): Promise<TreeNode[]> => {
        try {
            // Extract owner and repo from the URL
            let owner = "";
            let repo = "";
            if (selectedProject?.p_url) {
                const parts = selectedProject.p_url.replace("https://github.com/", "").split("/");
                owner = parts?.[0];
                repo = parts?.[1];
            }
            console.log("TOken:", selectedProject);
            
            const token = selectedProject?.p_token;
            const headers = token ? { Authorization: `Bearer ${token}`, Accept: "application/vnd.github+json" } : {};
            const response = await axios.get(
                `https://api.github.com/repos/${owner}/${repo}/contents/${path}`,
                { headers }
            );

            console.log(response.data)
            if (Array.isArray(response.data)) {
                return response.data.map((item: FileItem) => ({
                    ...item,
                    children: item.type === "dir" ? [] : undefined, // Only folders have children
                    isOpen: false, // Default to closed
                }));
            }
            else {
                console.log("File content retrieved:", response.data.content);
                const fileName = response.data.name
                console.log("fetchGitHubFiles filename", fileName)
                const content = response.data.content
                const decodedContent = atob(content);
                const hashmap = { fileName: fileName, content: decodedContent, fullFilePath: path };
                onContentChange(hashmap);
                return []; // Return empty or handle content-specific logic here
            }
        } catch (err) {
            console.error(err);
            return [];
        }
    };

    const toggleFolder = async (node: TreeNode) => {
        // if (!node.isOpen && node.type === "dir") {
        if (!node.isOpen) {
            // Fetch children only when expanding
            const children = await fetchGitHubFiles(node.path);
            console.log("children", children)
            node.children = children;
        }
        node.isOpen = !node.isOpen; // Toggle open/close state
        setTree([...tree]); // Trigger re-render
    };


    useEffect(() => {
        const loadRoot = async () => {
            const rootFiles = await fetchGitHubFiles();
            setTree(rootFiles);
            setFilteredTree(rootFiles);
        };
        loadRoot();
    }, []);

    // Debounced search effect
    useEffect(() => {
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
            if (!searchText.trim()) {
                setFilteredTree(tree);
            } else {
                // Recursively filter tree nodes by file/folder name
                const filterNodes = (nodes: TreeNode[]): TreeNode[] => {
                    return nodes
                        .map(node => {
                            if (node.type === 'dir' && node.children && node.children.length > 0) {
                                const filteredChildren = filterNodes(node.children);
                                if (
                                    node.name.toLowerCase().includes(searchText.toLowerCase()) ||
                                    filteredChildren.length > 0
                                ) {
                                    return { ...node, children: filteredChildren, isOpen: true };
                                }
                                return null;
                            } else {
                                if (node.name.toLowerCase().includes(searchText.toLowerCase())) {
                                    return node;
                                }
                                return null;
                            }
                        })
                        .filter(Boolean) as TreeNode[];
                };
                setFilteredTree(filterNodes(tree));
            }
        }, 300); // 300ms debounce
        return () => {
            if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        };
    }, [searchText, tree]);

    return (
        <div className="fileExplorer">
            <div className="search-bar-wrapper">
                <div className="searchBar">
                    <img className="search-icon" src={Icons.Search} alt="search" />
                    <input
                        className="search"
                        placeholder="Search file"
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                    />
                </div>
            </div>

            <ul className="folder-content">
                {filteredTree.map((node) => (
                    <TreeNodeComponent
                        key={node.sha}
                        node={node}
                        toggleFolder={toggleFolder}
                        codeContent={content}
                    />
                ))}

                {
                    (tree.length === 0 || filteredTree.length === 0) && <div className='no-record'>No files found in this repo</div>
                }
            </ul>
        </div>
    );
};


export default FolderStructure;